/*
*/

document.addEventListener('click', function(e) {
  const link = e.target.closest('a[href="#ask-tom"]');
  if (!link) return;

  e.preventDefault();

  const tom = document.getElementById('boei_button');
  if (tom) tom.click();
});
